import React, { useEffect, useState } from 'react';
import cssstyle from './BannerProgressCircle.scss';
import { Icon } from '../../../../common/Icon';

export const BannerProgressCircle = ({ style, size, strokeWidth, percentage, withProgress, state, color, isInMedia }) => {
    const { status, progressCircleColor = color } = state;
    const [progress, setProgress] = useState(0);
    useEffect(() => {
        setProgress(percentage);
    }, [percentage]);

    const viewBox = `0 0 ${size} ${size}`;
    const radius = (size - strokeWidth) / 2;
    const circumference = radius * Math.PI * 2;
    const dash = progress * circumference / 100;
    const getCircleBackground = isInMedia ? 'rgba(0, 0, 0, 0.4' : '#ccc';

    return (
        <div>
        <svg className={style} width={size} height={size} viewBox={viewBox}>
            <circle
                fill="none"
                stroke={getCircleBackground}
                cx={size / 2}
                cy={size / 2}
                r={radius}
                strokeWidth={`${strokeWidth}px`}
            />
            <circle
                fill="none"
                stroke={progressCircleColor}
                cx={size / 2}
                cy={size / 2}
                r={radius}
                strokeWidth={`${strokeWidth}px`}
                transform={`rotate(-90 ${size / 2} ${size / 2})`}
                strokeDasharray={[dash, circumference - dash]}
                strokeLinecap="butt"
                style={{ transition: 'all 0.5s' }}
            />
            {withProgress && status === 'active' && <text
                className={cssstyle.fontStyle}
                fill="var(--missions-details-process-bar-and-text-color)"
                x="50%"
                y="50%"
                dy="7px"
                textAnchor="middle"
            >
                {`${percentage}%`}
            </text>}

        </svg>
            {withProgress && status === 'completed' && <div className={cssstyle.tickWrapper}><Icon type="missionsTickCircle" /></div>}
            {withProgress && status === 'notStarted' && <div className={cssstyle.tickWrapperNotStarted}><Icon type="missionsIconHeaderNotStarted" /></div>}
            {withProgress && status === 'incompleted' && <div className={cssstyle.tickWrapperIncompleted}><Icon type="missionsIconHeaderIncompleted" /></div>}
        </div>
    );
};
